import { Icon } from '@/components/ui/icon';
import VisibleLoading from '@/components/utilities/VisibleLoading';

const FeaturesSimpleCardsContainer = ({ simpleCards }) => {
  return (
    <div className="mx-auto mt-6 mb-6 w-[calc(90vw-16)] px-4 xl:w-(--container-width) xl:px-0">
      <div className="-mx-4 mt-12 flex items-stretch gap-x-6 gap-y-12 overflow-x-auto overflow-y-hidden px-4 py-3 lg:mx-0 lg:justify-center lg:overflow-x-visible lg:overflow-y-visible lg:px-0 lg:py-0 xl:flex-wrap">
        {(simpleCards || []).map((card, index) => (
          <VisibleLoading key={card.id} delay={index * 100}>
            {({ ref, className }) => (
              <FeaturesSimpleCard innerRef={ref} className={className} key={card.id} card={card} />
            )}
          </VisibleLoading>
        ))}
      </div>
    </div>
  );
};
export default FeaturesSimpleCardsContainer;

const colors = [
  'bg-green-500',
  'bg-green-700',
  'bg-blue-500',
  'bg-blue-700',
  'bg-yellow-500',
  'bg-yellow-700',
  'bg-red-500',
  'bg-red-700',
  'bg-brand-500',
  'bg-brand-700',
  'bg-purple-500',
  'bg-purple-700'
];

const FeaturesSimpleCard = ({ innerRef, className, card }) => {
  const backgroundColor = `bg-${card.color}`.replace('_', '-');

  const iconColorClassName = colors.includes(backgroundColor) ? backgroundColor : 'bg-brand-500';
  const variantClassName = card.variant === 'light' ? 'border-grey-200' : 'border-grey-700';

  return (
    <div
      ref={innerRef}
      className={`flex w-[260px] min-w-[260px] flex-col justify-between gap-4 rounded-2xl border p-6 text-left ${variantClassName} ${className || ''}`.trim()}
    >
      {card.description ? (
        <>
          <div>
            <div
              className={`${iconColorClassName} flex h-[48px] w-[48px] items-center justify-center rounded-full text-white`}
            >
              <Icon type={card.icon} width={24} height={24} />
            </div>

            <h3 className="mt-6 text-left text-xl font-light tracking-tight lg:text-2xl">{card.title}</h3>
          </div>

          <p className="text-sm lg:text-base">{card.description}</p>
        </>
      ) : (
        <>
          <div>
            <div
              className={`${iconColorClassName} flex h-[48px] w-[48px] items-center justify-center rounded-full text-white`}
            >
              <Icon type={card.icon} width={24} height={24} />
            </div>

            <div className="txt-xl mt-4 text-left font-medium tracking-tight">{card.title}</div>
          </div>
        </>
      )}
    </div>
  );
};
